import Lights from "./Lights.jsx";
import { Physics } from "@react-three/rapier";
import { useCameraStore } from "./stores/useCameraStore.jsx";
import { Perf } from "r3f-perf";
import { useDebugMode } from "./hooks/useDebugMode.jsx";
import { Environment, OrbitControls } from "@react-three/drei";
import BarScene from "./BarScene.jsx";
import ComicPostProcessing from "./ComicPostProcessing.jsx";
import { useThree, useFrame } from "@react-three/fiber";
import { Float } from "@react-three/drei";
import { useSplashStore } from "./stores/useSplashStore.jsx";
import { useRef, useEffect, useState } from "react";
import * as THREE from "three";
import { EffectComposer } from "@react-three/postprocessing";
import { Bloom } from "@react-three/postprocessing";
import { Vignette } from "@react-three/postprocessing";

export default function Experience() {
  const { cameraMode } = useCameraStore();
  const isDebugMode = useDebugMode();
  const { gl, camera } = useThree();
  const { isStarting } = useSplashStore();
  const animatingCamera = useRef(false);
  const animationProgress = useRef(0);
  const orbitControlsRef = useRef();
  const hasAnimated = useRef(false);
  const [controlsEnabled, setControlsEnabled] = useState(false);

  const startCameraPosition = useRef(new THREE.Vector3(0, 5, 15));
  const targetCameraPosition = useRef(new THREE.Vector3(0, 0.8, 5.5));

  useEffect(() => {
    camera.position.copy(startCameraPosition.current);
    camera.lookAt(0, 0, 0);
  }, [camera]);

  useEffect(() => {
    if (isStarting && !hasAnimated.current) {
      hasAnimated.current = true;
      animatingCamera.current = true;
      animationProgress.current = 0;
    }
  }, [isStarting]);

  useFrame((state, delta) => {
    if (animatingCamera.current) {
      animationProgress.current += delta * 0.5;

      if (animationProgress.current >= 1) {
        animationProgress.current = 1;
        animatingCamera.current = false;
        setControlsEnabled(true);
      }

      const t = THREE.MathUtils.smoothstep(animationProgress.current, 0, 1);
      camera.position.lerpVectors(
        startCameraPosition.current,
        targetCameraPosition.current,
        t
      );
      camera.lookAt(0, 0, 0);
    }
  });

  return (
    <>
      {isDebugMode && <Perf position="bottom-right" />}
      <color attach="background" args={["#966359"]} />
      <fog attach="fog" args={["#2b1705", 5, 15]} />
      <Environment
        files="./assets/warm_bar_1k.hdr"
        background
        backgroundBlurriness={0.5} // optional blur factor between 0 and 1 (default: 0, only works with three 0.146 and up)
        backgroundIntensity={0.05} // optional intensity factor (default: 1, only works with three 0.163 and up)
        backgroundRotation={[0, Math.PI / 2, 0]} // optional rotation (default: 0, only works with three 0.163 and up)
      />
      <Lights />
      <OrbitControls
        ref={orbitControlsRef}
        enabled={controlsEnabled}
        enablePan={true}
        enableZoom={true}
        enableRotate={true}
        minDistance={4}
        maxDistance={12}
        minPolarAngle={Math.PI / 4}
        maxPolarAngle={Math.PI / 2.2}
        minAzimuthAngle={-Math.PI / 3}
        maxAzimuthAngle={Math.PI / 3}
        panSpeed={0.3}
        rotateSpeed={0.4}
        zoomSpeed={0.5}
      />
      <Float speed={1.5} floatIntensity={1} rotationIntensity={0.2}>
        <BarScene />
      </Float>
      <ComicPostProcessing />
      {/* <EffectComposer>
        <Bloom intensity={0.25} luminanceThreshold={0.4} />
        <Vignette eskil={false} offset={0.3} darkness={0.4} />
      </EffectComposer> */}
    </>
  );
}
